import React from 'react';
import PropTypes from 'prop-types';
import ResourcesListItem from '../resources-list-item';
import ThumbListItem from '../thumb-list-item';
import ResourceType from '../../types/resource';

import './thumb-list.css';

const ThumbList = ({ resources, selectedIndex, onSelect, onInsert, onChangeLocation, ...otherProps }) => (
  <div className="resource-dialog__thumb-list">
    {resources.map((resource, index) =>
      (<ResourcesListItem
        {...otherProps}
        key={`thumb-item-${resource.fullPath}`}
        index={index}
        isSelected={index === selectedIndex}
        onSelect={onSelect}
        onInsert={onInsert}
        onChangeLocation={onChangeLocation}
        resource={resource}
      >
        {props => <ThumbListItem {...props} />}
      </ResourcesListItem>)
    )}
  </div>
);

ThumbList.propTypes = {
  resources: PropTypes.arrayOf(ResourceType).isRequired,
  onInsert: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default ThumbList;